import React, { useState, useMemo } from 'react';
import css from './Table.module.css';
import componentFunctions from '../../../../services/tools/componentFunctions';
import { Link, useNavigate } from 'react-router-dom';

function Table({ data, detailsTo }) {
    const [filter, setFilter] = useState('');
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    const headers = Object.keys(data[0]);

    // console.log(caller);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                    //box-shadow: 0 0 8px 0 #54b5f7;
                    // style={{color: isError ? "red" : "black"}}
                />
                <div
                    className={
                        sortedAndFilteredData.length === 0
                            ? `${css.filterCount} ${css.filterCountZero}`
                            : css.filterCount
                    }
                >
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
            </div>

            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        {headers.map((header) => (
                            <th
                                key={header}
                                onClick={() => requestSort(header)}
                                className={css.th}
                                style={{ cursor: 'pointer' }}
                            >
                                {header}
                                {sortConfig.key === header
                                    ? sortConfig.direction === 'ascending'
                                        ? ' 🔼'
                                        : ' 🔽'
                                    : ''}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((item, index) => (
                            <tr
                                key={item[Object.keys(item)[0]]}
                                id={item[Object.keys(item)[0]]}
                                onClick={() => navigate(detailsTo + item.ID)}
                                className={css.row}
                            >
                                {headers.map((header, headerIndex) => (
                                    <td
                                        key={headerIndex}
                                        className={
                                            ['DoB', 'Date', 'Start', 'End'].includes(header) ? css.tdWide : css.td
                                        }
                                    >
                                        {header === 'L' ? (
                                            <Link to={item[header]} target="_blank" rel="noopener noreferrer">
                                                <i className="fa-regular fa-file-lines"></i>{' '}
                                            </Link>
                                        ) : (
                                            item[header]
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default Table;
